<script lang="ts">
	//Services
	import { format } from '../../../../../services/i18n';
	import { localReq, postReq } from '../../../../../services/http';
	//Helpers
	import { get_local_ip, real_id } from '../../../../../helpers/interface_helpers';
	import { formatSnakeCaseToTitle } from '../../../../../helpers/utilities';
	//Stores
		import { getDeviceStatus, getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Design system components
	import { Button, Checkbox, Radio, toast } from '@Shelly/shelly-design-system';

	export let device;

	const id = real_id(device.id);

	$: settingsStore = getDeviceSettings(id);
	$: settings = $settingsStore;

	const btn_types = ['one_button', 'dual_button', 'toggle', 'edge', 'detached', 'action'];

	let reverse = $settingsStore[device.category + 's'][device.channel].swap_inputs;
	let cacheReverse = reverse;
	let index = btn_types.indexOf($settingsStore[device.category + 's'][device.channel].btn_type);
	let cacheIndex = index;
	let loading = false;

	//Dimmer settings
	const options = [
		$format('option_one_button_mode', {
			default: 'One button mode - dimmer is controlled with single switch.',
		}),
		$format('option_dual_button_mode', {
			default: 'Dual button mode - dimmer is controlled with dual switch.',
		}),
		$format('option_toggle_switch', {
			default: 'Toggle switch one button - toggle mode with single switch.',
		}),
		$format('option_edge_switch', {
			default: 'Edge switch - edge on/off mode with single switch.',
		}),
		$format('option_detached_button', {
			default: "Detached - switch doesn't control dimmer output.",
		}),
		$format('option_activation_switch', {
			default:
				'Activation Switch - use it for motion sensor. Any input turns "ON" and resets Auto OFF timer.',
		}),
	];

	let localIp = get_local_ip(id);

	const toggleReverse = () => {
		reverse = !reverse;
	};

	const setType = (val) => {
		index = val;
	};

	const sentRequests = async () => {
		let setBtnType; //prepare variable for first promise
		let handleToggle; //prepare variable for second promise
		if (cacheIndex !== index) {
			loading = true;
			if (localIp) {
				setBtnType = await localReq(
					device,
					`${localIp}/settings/${device.category}/${device.channel}`,
					'post',
					{
						btn_type: btn_types[index],
					},
				);
			} else {
				setBtnType = await postReq(`/device/${device.category}/settings/button_type`, {
					id: id,
					channel: device.channel,
					type: btn_types[index],
				});
			}
		}
		if (cacheReverse !== reverse) {
			loading = true;
			if (localIp) {
				handleToggle = await localReq(
					device,
					`${localIp}/settings/${device.category}/${device.channel}`,
					'post',
					{
						swap_inputs: reverse ? 1 : 0,
					},
				);
			} else {
				handleToggle = await postReq(`/device/${device.category}/settings/swap_inputs`, {
					id: id,
					channel: device.channel,
					swap_inputs: reverse ? 1 : 0,
				});
			}
		}
		Promise.all([setBtnType, handleToggle]).then((res) => {
			if (typeof res[0] !== 'undefined') {
				if (res[0].isok) {
					settings[device.category + 's'][device.channel].btn_type = btn_types[index];
					devices_settings.update_devices_settings(id, settings);
					toast.open({
						type: 'success',
						title:
							$format('btn_type_scc_toast', {
								values: {
									type_value: formatSnakeCaseToTitle(btn_types[index]),
								},
							}) ||
							`Button type was changed to ${formatSnakeCaseToTitle(btn_types[index])}.`,
					});
					cacheIndex = index;
				} else {
					toast.open({ type: 'danger', title: $format('error_global') });
					index = cacheIndex;
				}
			}
			if (typeof res[1] !== 'undefined') {
				if (res[1].isok) {
					settings[device.category + 's'][device.channel].swap_inputs = reverse;
					devices_settings.update_devices_settings(id, settings);
					toast.open({
						type: 'success',
						title: $format('swap_inputs_scc_toast') || `Inputs was swapped.`,
					});
					cacheReverse = reverse;
				} else {
					toast.open({ type: 'danger', title: $format('error_global') });
					reverse = cacheReverse;
				}
			}
			loading = false;
		});
	};
</script>

{#each btn_types as _type, i}
	<Radio
		size="m"
		selected={index.toString()}
		value={i.toString()}
		on:click={() => setType(i)}
		id="radio-ixe58v6">{options[i]}</Radio
	>
{/each}
<Checkbox size="m" checked={reverse} on:click={toggleReverse} id="checkbox-hnt4vnc"
	>{$format('option_swap_inputs', {
		default:
			'Swap inputs - If you enable this option, the buttons On/Off position will be inverted.',
	})}</Checkbox
>

<Button {loading} size="m" width="full" on:click={sentRequests}>{$format('button_save')}</Button>
